var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDefaultLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 53,
    height: 52,
    viewBox: "0 0 53 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_4404_80406",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 53,
    height: 52
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M.29 24c0-11.314 0-16.97 3.514-20.485C7.319 0 12.975 0 24.289 0h4c11.314 0 16.97 0 20.485 3.515C52.29 7.029 52.29 12.686 52.29 24v4c0 11.314 0 16.97-3.515 20.485C45.26 52 39.603 52 28.29 52h-4c-11.314 0-16.97 0-20.485-3.515C.289 44.971.289 39.314.289 28v-4Z",
    fill: "#fff"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_4404_80406)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M.29 24c0-11.314 0-16.97 3.514-20.485C7.319 0 12.975 0 24.289 0h4c11.314 0 16.97 0 20.485 3.515C52.29 7.029 52.29 12.686 52.29 24v4c0 11.314 0 16.97-3.515 20.485C45.26 52 39.603 52 28.29 52h-4c-11.314 0-16.97 0-20.485-3.515C.289 44.971.289 39.314.289 28v-4Z",
    fill: "#F8F8F8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.924 28.783h4.47v-.84h-3.52v-6.2h-.95v7.04Zm7.361.14c1.47 0 2.49-1.09 2.49-2.64s-1.02-2.64-2.49-2.64c-1.47 0-2.49 1.09-2.49 2.64s1.02 2.64 2.49 2.64Zm-1.55-2.64c0-1.13.61-1.86 1.55-1.86.94 0 1.55.73 1.55 1.86 0 1.13-.61 1.86-1.55 1.86-.94 0-1.55-.73-1.55-1.86Zm7.034 4.59c1.47 0 2.34-.88 2.34-2.38v-4.71h-.88v.81c-.35-.65-.96-.95-1.64-.95-1.28 0-2.21 1.08-2.21 2.61 0 1.54.94 2.62 2.24 2.62.68 0 1.27-.3 1.61-.95v.61c0 1-.54 1.58-1.46 1.58-.71 0-1.21-.33-1.34-.91h-.98c.16 1.06 1.04 1.67 2.32 1.67Zm-1.45-4.62c0-1.12.6-1.83 1.45-1.83.88 0 1.47.74 1.47 1.83 0 1.12-.58 1.84-1.47 1.84-.86 0-1.45-.71-1.45-1.84Zm7.212 2.67c1.47 0 2.49-1.09 2.49-2.64s-1.02-2.64-2.49-2.64c-1.47 0-2.49 1.09-2.49 2.64s1.02 2.64 2.49 2.64Zm-1.55-2.64c0-1.13.61-1.86 1.55-1.86.94 0 1.55.73 1.55 1.86 0 1.13-.61 1.86-1.55 1.86-.94 0-1.55-.73-1.55-1.86Z",
    fill: "#1F1F1F"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefaultLogo);
export default __webpack_public_path__ + "static/media/default-logo.ad75c45c5b8480ff7cff8e7200732df7.svg";
export { ForwardRef as ReactComponent };